import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './Logo';
import { useLang } from '../context/LanguageContext';
import t from '../translations';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { lang, toggle } = useLang();
  const tx = t[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close drawer on route change
  const closeDrawer = () => {
    setOpen(false);
    document.body.style.overflow = '';
  };

  const toggleDrawer = () => {
    const next = !open;
    setOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
  };

  return (
    <>
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="container">
          <div className="nav-inner">
            <NavLink to="/" className="nav-brand" onClick={closeDrawer}>
              <Logo size={38} />
              <div className="nav-brand-text">
                <span className="name">XSC <span>Invest</span></span>
                <span className="sub">Property Maintenance</span>
              </div>
            </NavLink>

            {/* Desktop links */}
            <ul className="nav-links">
              <li><NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>{tx.home}</NavLink></li>
              <li><NavLink to="/services" className={({ isActive }) => isActive ? 'active' : ''}>{tx.services}</NavLink></li>
              <li><NavLink to="/contact" className={({ isActive }) => `nav-cta${isActive ? ' active' : ''}`}>{tx.contact}</NavLink></li>
              <li>
                <button onClick={toggle} style={{
                  background: 'rgba(255,255,255,0.12)',
                  border: '1.5px solid rgba(255,255,255,0.3)',
                  color: '#fff',
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '12px',
                  fontWeight: '700',
                  letterSpacing: '0.8px',
                  textTransform: 'uppercase',
                  padding: '7px 14px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}>
                  {lang === 'en' ? '🇪🇸 ES' : '🇺🇸 EN'}
                </button>
              </li>
            </ul>

            {/* Burger button */}
            <button
              className={`burger${open ? ' open' : ''}`}
              onClick={toggleDrawer}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div className={`nav-drawer${open ? ' open' : ''}`}>
        <NavLink to="/" end onClick={closeDrawer}>{tx.home} <span className="arrow">›</span></NavLink>
        <NavLink to="/services" onClick={closeDrawer}>{tx.services} <span className="arrow">›</span></NavLink>
        <NavLink to="/contact" className="drawer-cta" onClick={closeDrawer}>{tx.contact}</NavLink>
        <button onClick={() => { toggle(); closeDrawer(); }} style={{
          marginTop: '16px',
          background: 'rgba(255,255,255,0.1)',
          border: '1.5px solid rgba(255,255,255,0.25)',
          color: '#fff',
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '16px',
          fontWeight: '700',
          padding: '14px 24px',
          borderRadius: '10px',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'left',
        }}>
          {lang === 'en' ? '🇪🇸 Cambiar a Español' : '🇺🇸 Switch to English'}
        </button>
      </div>
    </>
  );
}
